import React, { FunctionComponent } from 'react';
import { range } from 'lodash';

import { AppointmentType, appointmentTypeMap } from './AppointmentList';

interface Props {
  onchange: (property: string, val: string) => void;
  property: string;
  appointmentType: AppointmentType;
  value: string;
}

export const StartsAfterDropdown: FunctionComponent<Props> = ({
  onchange,
  property,
  appointmentType,
  value,
}) => (
  <div className="input-container input-select-container">
    <label>{appointmentTypeMap[appointmentType]} Starts After</label>
    <select
      className="prodigy-select"
      onChange={(e) => onchange(property, e.target.value)}
      id={`${appointmentType}-starts-after`}
      name={`${appointmentType}-starts-after`}
      value={value}
    >
      {range(25).map((i) => (
        <option key={i} value={`${i} hours`}>
          {i} hours
        </option>
      ))}
    </select>
  </div>
);
